import { Routes } from '@angular/router';
import { PageTitleEnum } from '@shared/enums';
import { userGuard } from '@core/guards';

export const accountSettingsRoutes: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('./_account-settings-layout/account-settings-layout.component').then(
                mod => mod.AccountSettingsLayoutComponent
            ),
        children: [
            {
                path: '',
                redirectTo: 'overview',
                pathMatch: 'full',
            },
            {
                path: 'overview',
                loadComponent: () =>
                    import('./account-overview/account-overview.component').then(mod => mod.AccountOverviewComponent),
                canActivate: [userGuard],
                title: PageTitleEnum.ACCOUNT_OVERVIEW,
                data: { preload: true },
            },
            {
                path: 'messages',
                loadComponent: () =>
                    import('./account-message-settings/account-message-settings.component').then(
                        mod => mod.AccountMessageSettingsComponent
                    ),
                canActivate: [userGuard],
                title: PageTitleEnum.ACCOUNT_MESSAGES,
            },
            {
                path: 'faq',
                loadComponent: () => import('./account-faq/account-faq.component').then(mod => mod.AccountFaqComponent),
                canActivate: [userGuard],
                title: PageTitleEnum.ACCOUNT_FAQ,
            },
            {
                path: 'update-settings',
                loadComponent: () =>
                    import('./account-update-settings/account-update-settings.component').then(
                        mod => mod.AccountUpdateSettingsComponent
                    ),
                canActivate: [userGuard],
                title: PageTitleEnum.ACCOUNT_UPDATE_SETTINGS,
                data: { preload: true },
            },
            {
                path: 'email-settings',
                loadComponent: () =>
                    import('./account-email-settings/account-email-settings.component').then(
                        mod => mod.AccountEmailSettingsComponent
                    ),
                canActivate: [userGuard],
                title: PageTitleEnum.ACCOUNT_EMAIL_SETTINGS,
            },
            {
                path: 'payment-settings',
                loadComponent: () =>
                    import('./account-payment-settings/account-payment-settings.component').then(
                        mod => mod.AccountPaymentSettingsComponent
                    ),
                canActivate: [userGuard],
                title: PageTitleEnum.ACCOUNT_PAYMENT_SETTINGS,
            },
            {
                path: 'addresses',
                loadComponent: () =>
                    import('./account-addresses/account-addresses.component').then(
                        mod => mod.AccountAddressesComponent
                    ),
                canActivate: [userGuard],
                title: PageTitleEnum.ACCOUNT_ADDRESSES,
            },
        ],
    },
];
